// 繁體中文表格（機器翻譯，未經人工審校 — ruling G4）。
// The Traditional Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const S = {
  loading: "載入中…",
  building: "正在產生…",
  layingOut: "正在排版…",
  makingFile: "正在產生檔案…",
  timedOut: "產生 10 秒未完成，已重新開始——請減少字元或換字型",
  loadFailed: "無法載入——請嘗試重新整理頁面",
  triangles: (n) => `${n.toLocaleString('en-US')} 個三角形`,
  loading3d: "正在載入 3D 檢視…",
  load3dFailed: "3D 檢視打不開——請再試一次",
  fontLoading: (family, got, total) => (total > 0 ? `正在載入 ${family} ${got} / ${total} MB` : `正在載入 ${family} ${got} MB`),
  fontLinkNote: (family) => `無法載入 ${family}——請檢查網路連線 · 繼續使用目前字型`,
  more: (n) => `還有 ${n} 項`,
  placeholder: {
    name: "例如 Big",
    phone: "0812345678",
  },
  emptyEl: "（空）",
  addTitle: "新增文字或圖示",
  resetWarning: "自訂排版已重設，新增的零件已被移除（按 ↶ 可復原）",
  hint: {
    touch: "在牌子上任意位置拖曳即可移動選取的零件——不必按在字母上",
    mouse: "用滑鼠拖曳零件，或使用方向鍵（Shift = 每次 1 公厘）",
  },
  ariaPreview: {
    front: "2D 預覽",
    back: "2D 預覽，背面",
  },
  iconSize: "圖示大小",
  textSize: "文字大小",
  roleLabel: {
    name: "名字",
    phone: "電話",
    text: "文字",
    icon: "圖示",
  },
  fieldLabel: {
    name: "寵物名字",
    phone: "電話號碼",
    text: "文字",
    icon: "圖示",
  },
  face: {
    back: "（背面）",
  },
  copied: "連結已複製——可直接貼到聊天中",
  copyManual: "自動複製沒有成功——請長按上方連結手動複製",
  shape: {
    circle: "圓形",
    bone: "骨頭",
    heart: "心形",
    paw: "爪印",
    cat: "貓頭",
  },
  template: {
    name: "只放名字",
    "name-phone": "名字 + 電話",
    "name-front-phone-back": "名字在正面，電話在背面",
    "icon-name": "圖示 + 名字",
    "icon-name-phone-back": "圖示 + 名字，電話在背面",
  },
  icon: {
    paw: "爪印",
    heart: "心形",
    bone: "骨頭",
    star: "星",
    fish: "魚",
    cat: "貓",
    dog: "狗",
    phone: "電話",
  },
  preset: {
    dog: "狗",
    cat: "貓",
    paw: "爪印",
    heart: "心形",
  },
  engravedNote: "雕刻字母與牌子同色——想要第二種顏色的字母請選「凸起」",
  singleColour: "單色——任何印表機都能印",
  threeMf: (tagName, textName, z, n) => `3MF 檔案：牌子 = 耗料 1（${tagName}），字母 = 耗料 2（${textName}）· 單噴頭：在 Z = ${z} 公厘處換色（第 ${n} 層 @0.2 公厘）——孔邊一圈也會用字母的顏色列印`,
  title: "寵物掛牌",
  lineNote: "要下載檔案請在一般瀏覽器中開啟 — 做好的設計會一併帶過去",
  lineOpen: "在瀏覽器中開啟",
  retryNote: "載入失敗 — 點按重新載入",
  faceBtn: {
    front: "正面",
    back: "背面",
  },
  ariaFace: {
    front: "正面",
    back: "背面",
  },
  faceNote: "從背面看 — 文字方向正常 · 背面固定雕深 0.6 公厘",
  gTag: "掛牌樣式",
  presetsLabel: "從預設開始",
  ariaPresets: "預設",
  templatesLabel: "版式",
  ariaTemplates: "版式",
  gShape: "形狀",
  shapesLabel: "掛牌形狀",
  ariaShapes: "掛牌形狀",
  sizeLabel: "掛牌大小",
  sizeHint: "參考大小：10 泰銖硬幣 = 26 公厘",
  sizeRanges: "貓/小型犬 25–30 · 中型犬 30–38 · 大型犬 38 公厘以上",
  holeLabel: "掛繩孔",
  holes: {
    inside: "牌內開孔",
    tab: "頂部掛耳",
  },
  thickLabel: "厚度",
  gColour: "顏色",
  modeLabel: "文字樣式",
  modes: {
    raised: "凸起",
    engraved: "雕刻",
  },
  colourLabel: {
    tag: "掛牌顏色",
    text: "文字顏色",
  },
  gAdv: "自己調整位置",
  advanced: "自訂",
  backToSimple: "← 返回簡單模式",
  resetTemplate: "重置為範本",
  cancel: "取消",
  confirmReset: "好，重置",
  ariaChips: "掛牌上的部件",
  ariaAdd: "新增部件",
  addText: "＋ 文字",
  ariaSheet: "調整選取的部件",
  sheetEmpty: "點按掛牌上的部件或上方的晶片，選取要調整的部件",
  emPre: "大小：",
  mmPost: " 公厘",
  nudgePre: "移動 0.25 公厘 · 旋轉 ",
  nudgePost: "°（點按 = 15°，長按 = 每次 1°）",
  ariaNudge: {
    left: "向左移動",
    up: "向上移動",
    down: "向下移動",
    right: "向右移動",
  },
  ariaRot: {
    ccw: "逆時針旋轉",
    cw: "順時針旋轉",
  },
  deletePiece: "刪除這個部件",
  aboutH2: "狗貓掛牌 — 名字 + 電話，雙色 3D 列印",
  aboutP: "為狗狗和貓咪設計掛牌：填入寵物名字和主人電話，從市面上買得到的耗材中選形狀、圖示和兩種顏色（掛牌 + 文字），然後免費下載多色列印用的 3MF 或單色列印用的 STL。瀏覽器裡免費用，無需安裝。",
  printLi1: "用 PLA 或 PETG 列印，層高 0.2 公厘",
  printLi2: "用 AMS/CFS 機器列印兩色 — 3MF 已把掛牌設為 1 號料、凸起文字設為 2 號料，實際顏色在切片軟體裡選",
  printLi3: "單噴頭印表機：在文字顏色下方給出的 Z 高度處暫停換料",
  footerNote: "每個掛牌都經過水密檢查 — 穿孔和孔周加固圈可直接使用",
  ariaDownloads: "下載",
  dlstl: "下載 STL",
  ariaShareUrl: "這個設計的連結",
  ariaClose: "關閉",
  // a link that cannot open (src/doc.js decodeFragment's codes, worded by src/ui/share-ui.js)
  link: {
    bad: "此連結無法使用 — 請重新取得連結",
    newer: "此連結來自較新的版本",
  },
  // What the worker reports, in words (ruling R9: the worker speaks codes, src/worded.js says them)
  worker: {
    fontLoad: "字型載入失敗 — 請再試一次",
    face: {
      front: "正面",
      back: "背面",
    },
    tooDetailed: (face) => `${face}的文字過於精細 — 請減少文字或更換字型`,
    missingChars: (label, chars) => `${label}：此字型沒有 ${chars}`,
    badChar: (label, point) => `${label}：含有無法使用的字元（${point}）— 請刪除後重新輸入`,
    leadingMark: (label) => `${label}以懸空的母音或聲調符號開頭 — 請在前面加上子音`,
    empty: "下載前請輸入寵物的名字",
    tooMany: (max) => `每面最多 ${max} 個元素`,
    quoteText: (text) => `「${text}」`,
    quoteIcon: (name) => `${name}圖示`,
    outside: (what) => `${what}超出了吊牌邊緣`,
    onHole: (what) => `${what}壓到了掛環孔`,
    overlap: (what) => `${what}與其他元素太近或重疊`,
    tooThin: (what) => `${what}太小，印不清楚`,
    tooThinBack: (what, factor) => `${what}對背面來說太小（背面約需正面的 ${factor} 倍大）`,
    tooThinBackFit: (what) => `${what}太小，無法刻在背面`,
    tooThinTag: (mm) => `吊牌太薄，無法在背面刻字 — 請把厚度調到 ${mm} 公釐以上`,
    holeWall: "掛環孔周圍的邊太薄 — 請加大吊牌或更換孔的樣式",
    noFit: {
      front: "文字對這個尺寸的吊牌來說太長",
      back: "背面文字對這個尺寸的吊牌來說太長",
    },
    wayOut: (why, way) => `${why} — ${way}`,
    way: {
      plain: "請加大吊牌或縮短文字",
      phone: "請加大吊牌、縮短文字，或把電話號碼移到背面",
    },
    phoneToBack: "把電話號碼移到背面",
  },
  // the name on this page's share card (R69): the page opens with no name, as it always has — the card shows one, in Latin (no bundled family has kana or Han)
  cardName: "Mochi",
};
export default S;
